<script>
    import EventBus from "../../bus/events";
    import {mapGetters} from "vuex";
    import {APP_CONFIG} from "../../config";
    import {axios} from '../../bootstrap'

    export default {
        data() {
            return {
                socialAuthLoading: false,
                credentials: {
                    email: null,
                    password: null
                }
            };
        },
        mounted() {
            this.$store.commit("setLoadingStatus", false);
        },
        computed: {
            ...mapGetters({
                errors: "getValidationErrors",
                loading: "getLoadingStatus"
            })
        },

        methods: {
            async login() {
                if (this.$store.getters.isAuthenticated) {
                    EventBus.$emit("user-authenticated");
                    return;
                }
                await this.$recaptchaLoaded()
                this.credentials.identityToken = await this.$recaptcha('login')
                let credentials = this.credentials;
                this.$store.commit("setLoadingStatus", true);
                await this.$store.dispatch("USER_LOGIN", {
                    user: credentials,
                    requestOptions: {
                        loginUrl: "clients/web/admin/login",
                        tokenName: "access_token"
                    }
                });
            },

            socialLogin(provider) {
                this.socialAuthLoading = true;
                axios.get(`${APP_CONFIG.URL}auth/${provider}`)
                    .then(res => {
                        window.location.assign(res.data.redirectUrl);
                    })
                    .catch(() => {
                        this.socialAuthLoading = false;
                        this.$notify({
                            message: "We could not initiate your login request",
                            title: "Login Failed",
                            position: "bottom-right"
                        });
                    });
            },

            hasValidationErrors() {
                return this.$store.getters.getValidationErrors.count();
            }
        }
    };
</script>
<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="login-content d-flex align-items-center">
                <div class="col-xl-6 col-lg-6 col-md-6 d-none d-lg-block">
                    <div class="col-9">
                        <div class="bg-white" align="center">
                            <img src="/images/logo2.png" class="img-fluid"/>
                        </div>
                        <div class="mb-4" align="center">
                            <object type="image/svg+xml" data="/images/developers.svg" class="img-fluid"/>
                        </div>
                        <h1 class="heading-info h-color mb-4">Engage your customers on any channel they prefer.</h1>
                        <p class="login-p">
                            Use our unified platform to access SMS, VAS
                            Services, Voice, Payments, Chats, USSD Codes and
                            Survey for your business. In a cost-effective way.
                        </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="card block block-bordered">
                        <div class="card-body block-content">
                            <div class="card-header bg-white" align="center">
                                <p class="heading-info fz-22">Log In to your account</p>
                                <span class="login-card-info">
                                  Don't have an account yet? &nbsp;
                                  <router-link :to="{ name: 'signup' }">Sign up</router-link>
                                </span>
                            </div>
                            <div class="form mt-4">
                                <div class="user">
                                    <div class="form-group">
                                        <el-input
                                                type="email"
                                                placeholder="Your email address"
                                                suffix-icon="si si-user"
                                                v-model="credentials.email"
                                        ></el-input>
                                        <div
                                                v-if="errors.email"
                                                :class="['text-danger', 'help-block']"
                                        >{{errors.email[0]}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <el-input
                                                type="password"
                                                placeholder="Password"
                                                suffix-icon="si si-lock"
                                                v-model="credentials.password"
                                        ></el-input>
                                        <div
                                                v-if="errors.password"
                                                :class="['text-danger', 'help-block']"
                                        >{{errors.password[0]}}
                                        </div>
                                    </div>
                                </div>

                                <el-button
                                        type="primary"
                                        class="btn-block mb-2"
                                        :loading="loading"
                                        @click="login"
                                >
                                    Login
                                </el-button>

                                <router-link :to="{ name: 'password'}" class="link help-block">Forgot password?</router-link>

                                <div class="mt-1 text-center">
                                    <p class="or">
                                        <span>or login with</span>
                                    </p>
                                </div>
                                <div class="flex-column pb-2">
                                    <el-button
                                            size="small"
                                            :loading="socialAuthLoading"
                                            @click="socialLogin('github')">
                                        <i class="mr-1 fab fa-github"/>
                                        Github
                                    </el-button>
                                    <el-button
                                            size="small"
                                            :disabled="socialAuthLoading"
                                            class="float-right"
                                            @click="socialLogin('google')"
                                    >
                                        <i class="mr-1 fab fa-google text-primary"/>
                                        Google
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-content login-footer">
                        <span class>By logging in to your account you agree to our</span>
                        <br/>
                        This site is protected by reCAPTCHA and the Google
                        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../sass/custom/mixins";

    .login-content {
        min-height: 100vh;
    }

    .heading-info {
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 0.5rem;
    }

    .h-color {
        color: #005da2;
    }

    .card-heading {
        text-align: left;
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-size: 22px;
        font-weight: bold;
    }

    .help-block {
        font-size: 13px;
    }

    .login-p {
        text-align: left;
        letter-spacing: 0;
        color: #2c3f58;
        opacity: 1;
        font-weight: 400;
        font-size: 14px;
    }

    .card {
        @include for-desktop-up() {
            margin-left: 10rem;
        }
    }

    .login-card-info {
        font-size: 16px;
        font-weight: 600;
        color: #778699;
        margin-top: 0%;
    }

    .link {
        font: 14px/22px;
        letter-spacing: 0;
        color: #2985ef;
        opacity: 1;
    }

    label {
        text-align: left;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        color: #254050;
        opacity: 1;
    }

    .login-btn {
        background: #2985ef 0% 0% no-repeat padding-box;
        border-color: #2985ef;
        border-radius: 8px;
        opacity: 1;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
        color: #ffffff;
    }

    .login-btn:hover {
        background-color: #ffffff;
        color: #2985ef;
        border-color: #2985ef;
        border-radius: 8px;
        opacity: 1;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
    }

    .login-footer {
        font-size: 9px;
        font-weight: 700;
        text-align: center;
        letter-spacing: 0;
        color: #778699;
        opacity: 1;
    }

    .card-footer {
        background-color: #ffffff;
    }

    .social-btn-text {
        font-size: 13px;
        color: #778699;
        font-weight: 500;
    }

    .text-facebook {
        color: #4267b2 !important;
        position: relative;
        top: 3px;
    }

    .text-google {
        color: #eac043 !important;
        position: relative;
        top: 3px;
    }

    .text-google2 {
        color: #ffffff !important;
        position: relative;
    }

    .text-google3 {
        color: #ffffff !important;
        position: relative;
        top: 3px;
    }

    .terms-link {
        text-decoration: none;
        font-weight: 800;
        color: #2985ef;
    }
</style>
